import React from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';

interface IEmptyStateProps {
    message: string;
    subMessage?: string;
}

const EmptyState: React.FC<IEmptyStateProps> = ({ message, subMessage }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                p: 3,
                textAlign: 'center',
            }}>
            <ChatOutlinedIcon
                sx={{
                    fontSize: 100,
                    color: theme[themeStyle].grey,
                    opacity: 0.5,
                    mb: 4,
                }}
            />

            <Typography
                variant="h5"
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    color: theme[themeStyle].tag_white,
                    mb: 1,
                }}>
                {message}
            </Typography>

            {subMessage && (
                <Typography
                    variant="body1"
                    sx={{
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        color: theme[themeStyle].grey,
                    }}>
                    {subMessage}
                </Typography>
            )}
        </Box>
    );
};

export default EmptyState;
